import { Directive, Input, TemplateRef } from '@angular/core';

/**
 * Directive to mark a template as a custom column renderer for a specific field
 * Usage: <ng-template appTableColumnTemplate="fieldName" let-row>
 *   {{ row.fieldName }}
 * </ng-template>
 */
@Directive({
  selector: '[appTableColumnTemplate]',
  standalone: true,
})
export class TableColumnTemplateDirective {
  @Input() appTableColumnTemplate!: string; // Column field name to target

  constructor(public templateRef: TemplateRef<any>) {}
}
